<template>
  <div class="products-list__container">
    <div class="products-list__products">
      <ProductCard
        v-for="(product, index) in products"
        :product="product"
        :key="`products-list-${index}-${product.uid || ''}`"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import ProductCard from '~/components/General/ProductCard/ProductCard';

export default defineComponent({
  name: 'ProductList',
  components: {
    ProductCard,
  },
  props: {
    products: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
});
</script>

<style lang="scss">
.products-list__products {
  padding: 2rem 0;
}
@include from-tablet-min {
  .products-list__products {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
